import { GuideData, ArchItem, EcoItem } from '@/model/data-model';

const data: GuideData = {
  archData: {
    currency: {
      nocoin: {
        id: 0,
        title: '无代币',
        desc: '也被称为无币区块链，无一般等价物，很难形成价值网络',
        cons: [
          '参与者均无法获得激励',
        ],
        pros: [
          '更加纯粹的专注于业务本身',
        ],
      },
      frommine_deflation: {
        id: 1,
        title: '通缩型代币',
        desc: '通过挖矿创造初始代币，但代币总量固定',
        cons: [
          '早期投资者介入不易',
        ],
        pros: [
          '早期用户获利更多',
        ],
      },
      frommine_inflation: {
        id: 2,
        title: '通胀型代币',
        desc: '通过挖矿创造初始代币，但代币上限不定',
        cons: [
          '经济模型决定了区块链的健康程度',
        ],
        pros: [
          '早期用户获利更多',
        ],
      },
    },
    ledger: {
      chain: {
        id: 3,
        title: '区块链',
        desc: '由比特币创造，将区块链以链状结构相连',
        cons: [
          '性能效率低下',
          '性能不易扩展',
        ],
        pros: [
          '久经考验，稳定',
        ],
      },
      dag: {
        id: 4,
        title: '单向无环图',
        desc: '有类似于区块链的性质，不过以图的形式使得并行性得到增强',
        cons: [
          '尚未大范围应用',
          '容错处理更复杂',
        ],
        pros: [
          '性能效率更高',
        ],
      },
    },
    contracts: {
      novm: {
        id: 9,
        title: '无法执行',
        desc: '不能执行任何智能合约，只能进行区块链预定的指定操作',
        cons: [
          '无法扩展功能',
        ],
        pros: [
          '高性能',
          '不容易产生漏洞',
        ],
      },
      limitstackvm: {
        id: 10,
        title: '受限栈模式',
        desc: '在比特币中使用，可以执行少量运行的命令',
        cons: [
          '功能少',
        ],
        pros: [
          '高性能',
          '少漏洞',
        ],
      },
      fullstackvm: {
        id: 11,
        title: '图灵完全',
        desc: '图灵完全的虚拟机，可以执行任何类型的逻辑',
        cons: [
          '常常出现漏洞',
        ],
        pros: [
          '性能保障机制复杂',
          '功能完整，可扩展性强',
        ],
      },
    },
    hash: {
      sha2: {
        id: 5,
        title: 'SHA2',
        desc: 'SHA算法家族的第二代，在比特币中使用为SHA256',
        cons: [
          '可能会在将来被攻破',
        ],
        pros: [
          '足够高的熵',
        ],
      },
      sha3: {
        id: 6,
        title: 'Keccak',
        desc: '也称SHA3，在以太坊中被使用',
        cons: [
          '计算速度慢',
        ],
        pros: [
          '暂时不担心攻破',
        ],
      },
    },
    signature: {
      ecdsa: {
        id: 7,
        title: '椭圆曲线',
        desc: 'ECDSA，被大部分区块链所采用',
        cons: [
          '性能略低',
        ],
        pros: [
          '存储空间少',
          '被区块链广泛使用',
        ],
      },
      rsa: {
        id: 8,
        title: 'RSA',
        desc: '经典的数字签名算法，广泛应用于银行、证书等领域',
        cons: [
          '存储空间占用大',
        ],
        pros: [
          '非常成熟，性能优',
          '在安全行业广泛使用',
        ],
      },
    },
    permission: {
      permissioned: {
        id: 12,
        title: '授权接入',
        desc: '只有获得授权的节点才可以接入区块链网络',
        cons: [
          '不开放，无法让所有人广泛参与',
        ],
        pros: [
          '成员受控，安全可控',
          '适合企业之间或内部使用',
        ],
      },
      public: {
        id: 13,
        title: '公开接入',
        desc: '任意节点均有机会接入到该区块链网络',
        cons: [
          '为解决女巫攻击的问题，需要精巧的设计',
        ],
        pros: [
          '接受任意成员的加入',
          '适合企业之间或内部使用',
        ],
      },
    },
    api: {
      rpc: {
        id: 14,
        title: '通用型接口',
        desc: '通常使用远程过程调用(RPC)，一种易扩展升级的接口，广泛用于区块链项目',
        cons: [
          '接口本身无描述',
        ],
        pros: [
          '接口标准',
          '易升级扩展',
        ],
      },
      restful: {
        id: 15,
        title: '描述型接口',
        desc: '以REST为代表的描述性接口，广泛用在网络应用中',
        cons: [
          '接口升级需要慎重的考虑',
        ],
        pros: [
          '接口标准',
          '接口描述明确详细，易于使用',
        ],
      },
    },
    consensus: {
      pow_sha2: {
        id: 16,
        title: '工作量证明-SHA2',
        simpleTitle: '工作量证明',
        desc: '在比特币中使用，通过大计算量避免女巫攻击',
        cons: [
          '消耗大量的能源',
        ],
        pros: [
          '成熟稳定',
          '作恶成本高',
        ],
        risk: [
          'cross_chain_hash_attack',
          'fifty_one',
          'double_spend',
          'selfish_mining',
        ],
      },
      pow_ethash: {
        id: 20,
        title: '工作量证明-Ethash',
        desc: '专门为以太坊设计的工作量证明算法',
        cons: [
          '消耗大量的能源',
        ],
        pros: [
          '成熟稳定',
          '作恶成本高',
        ],
        risk: [
          'cross_chain_hash_attack',
          'fifty_one',
          'double_spend',
          'selfish_mining',
        ],
      },
      pow_newalgo: {
        id: 17,
        title: '工作量证明-新方法',
        simpleTitle: '新工作量证明',
        desc: '通过大计算量避免女巫攻击，通过设计新的方法，避免跨链算力攻击',
        cons: [
          '消耗大量的能源',
          '不成熟和稳定',
        ],
        pros: [
          '作恶成本高',
        ],
        risk: [
          'fifty_one',
          'double_spend',
          'selfish_mining',
        ],
      },
      pos_casper: {
        id: 21,
        title: '权利证明-casper',
        desc: '专门为以太坊设计的权力证明算法，通过抵押以太币来挖矿',
        cons: [
          '尚未能证明其防攻击能力',
        ],
        pros: [
          '避免能源消耗',
        ],
        risk: [
          'sybil_attack',
          'long_range',
        ],
      },
      pos_standard: {
        id: 18,
        title: '权利证明',
        desc: '根据在区块链上所拥有的权利（股权）来获得记账（并获得收益）的概率',
        simpleDesc: '根据在区块链上所拥有的权利来获得记账的概率',
        cons: [
          '很难防止女巫攻击',
        ],
        pros: [
          '避免能源消耗',
        ],
        risk: [
          'sybil_attack',
          'long_range',
        ],
      },
      pos_algorand: {
        id: 22,
        title: '权利证明-Algorand',
        desc: '由Algorand设计的一种权利证明机制，通过数学随机数的方法，使得每个用户获得记账概率进行了平均',
        cons: [
          '尚未能证明其防攻击能力',
        ],
        pros: [
          '避免能源消耗',
          '避免单个用户拥有过多的权利',
        ],
        risk: [
          'sybil_attack',
          'long_range',
        ],
      },
      dpos_standard: {
        id: 19,
        title: '委托权利证明',
        desc: '将拥有的区块链权利委托给部分用户，这部分用户平均分配获得记账概率',
        simpleDesc: '将拥有的权利委托给部分用户，他们将平均获得记账权',
        cons: [
          '尚未能证明其防攻击能力',
        ],
        pros: [
          '避免能源消耗',
        ],
        risk: [
          'sybil_attack',
          'long_range',
        ],
      },
      // risk: [
      //   'fifty_one',
      //   'double_spend',
      //   'sybil_attack',
      //   'selfish_mining',
      //   'long_range',
      //   'cross_chain_hash_attack',
      // ],
    },
  },
  archList: [],
  typeData: {
    currency: {
      title: '① 代币机制',
      desc: '决定了区块链的价值如何体现与流转',
    },
    ledger: {
      title: '② 账本模式',
      desc: '区块之间的连接方式决定了区块链的并行性',
    },
    contracts: {
      title: '⑤ 智能合约',
      desc: '用于执行逻辑，使区块链具备更好的扩展性',
    },
    hash: {
      title: '③ 数字摘要',
      desc: '标识信息唯一性的数学方法',
    },
    signature: {
      title: '④ 数字签名',
      desc: '基于困难的数学问题，使得签名可以安全防伪',
    },
    permission: {
      title: '⑥ 权限控制',
      desc: '决定区块链如何接纳新的节点成员',
    },
    api: {
      title: '⑦ 接口设计',
      desc: '决定区块链的对外接口的设计模式',
    },
    consensus: {
      title: '⑧ 共识机制',
      desc: '多个节点如何获得记账权限的策略机制',
    },
    incentive: {
      title: '激励',
      desc: '提供激励以鼓励达成共识的参与者，积极地参与到区块链的稳定运行中',
    },
    governance: {
      title: '治理',
      desc: '提供如何更新代码、管理初始资金并协调区块链参与者',
    },
    dapp: {
      title: 'DApp',
      desc: '更为复杂和综合的智能合约',
    },
  },
  ecoData: {
    incentive: {
      mine: {
        id: 'ei1',
        icon: 'briefcase',
        title: '挖矿激励',
      },
      fee: {
        id: 'ei2',
        icon: 'money-bill',
        title: '交易费',
      },
      profitsharing: {
        id: 'ei3',
        icon: 'handshake',
        title: '分红',
      },
    },
    governance: {
      voting_code: {
        id: 'eg1',
        icon: 'poll',
        title: '通过投票提交代码更改',
      },
      committee_code: {
        id: 'eg2',
        icon: 'users',
        title: '通过委员会审核代码',
      },
      foundation: {
        id: 'eg3',
        icon: 'hands-helping',
        title: '由非营利组织管理协调社区、资金',
      },
      company: {
        id: 'eg4',
        icon: 'building',
        title: '由公司管理管理协调社区、资金',
      },
      voting_community: {
        id: 'eg5',
        icon: 'book',
        title: '社区自组织，由投票表决',
      },
    },
    dapp: {
      oracle: {
        id: 'ed1',
        icon: 'american-sign-language-interpreting',
        title: '链下预测服务',
      },
      central_exchange: {
        id: 'ed2',
        icon: 'exchange-alt',
        title: '中心化交易所',
      },
      distributed_exchange: {
        id: 'ed3',
        icon: 'link',
        title: '去中心交易所',
      },
    },
  },
  ecoList: [],
  riskData: {
    fifty_one: {
      icon: 'carrot',
      text: '51%算力攻击',
      desc: '由全网算力超过51%的拥有者发起，导致历史被修改的攻击',
    },
    double_spend: {
      icon: 'carrot',
      text: '双花攻击',
      desc: '当使用区块链中的代币进行链下交易时，由于（临时）历史的变更，使得一笔钱被花在两个地方',
    },
    sybil_attack: {
      icon: 'carrot',
      text: '女巫攻击',
      desc: '利用单个节点伪装成多个节点，以削弱网络的冗余性、健壮性，并干扰正常的网络活动',
    },
    selfish_mining: {
      icon: 'carrot',
      text: '自私挖矿攻击',
      desc: '具有挖矿优势的矿工私藏已成功挖到块，并继续挖矿以延续优势，使得其他矿工更加处于劣势，而无法获得挖矿奖励',
    },
    long_range: {
      icon: 'carrot',
      text: '长程攻击',
      desc: '由历史上拥有过绝大多数股权的控制人发起，导致历史被修改的攻击',
    },
    cross_chain_hash_attack: {
      icon: 'carrot',
      text: '跨链算力攻击',
      desc: '新链使用成熟的算力算法时，非常容易被现行矿池进行51%算力攻击',
    },
  },
  coins: [
    {
      id: 'btc',
      icon: 'btc',
      name: '比特币',
      desc: '最初由中本聪在2008年提出，并于2009年正式上线。比特币是一种点对点形式的虚拟的加密数字货币。与以往的货币不同，比特币不依靠特定货币机构发行，它依据特定算法，通过大量的计算产生',
      char: {
        currency: 'frommine_deflation',
        ledger: 'chain',
        hash: 'sha2',
        signature: 'ecdsa',
        contracts: 'limitstackvm',
        permission: 'public',
        api: 'rpc',
        consensus: 'pow_sha2',
        incentive: [],
        governance: [],
        dapp: [],
      },
    },
    {
      id: 'eth',
      icon: 'eth',
      name: '以太坊',
      desc: '概念首次在2013年由Vitalik受比特币启发后提出，大意为“下一代加密货币与去中心化应用平台”，在2014年通过ICO众筹开始得以发展。以太币是市值第二高的加密货币，仅次于比特币。',
      char: {
        currency: 'frommine_inflation',
        ledger: 'chain',
        hash: 'sha3',
        signature: 'ecdsa',
        contracts: 'fullstackvm',
        permission: 'public',
        api: 'rpc',
        consensus: 'pos_standard',
        incentive: [],
        governance: [],
        dapp: [],
      },
    },
    {
      id: 'eos',
      icon: 'eos',
      name: 'EOS',
      desc: '引入的一种新的区块链架构，旨在实现分布式应用的性能扩展。它并不是像比特币和以太坊那样，直接是货币，而是基于其公链进行发币，被称为区块链3.0。',
      char: {
        currency: 'frommine_inflation',
        ledger: 'chain',
        hash: 'sha2',
        signature: 'ecdsa',
        contracts: 'fullstackvm',
        permission: 'permissioned',
        api: 'rpc',
        consensus: 'dpos_standard',
        incentive: [],
        governance: [],
        dapp: [],
      },
    },
  ],
    modes: {
      standard: {
        name: '标准',
        id: 'standard',
        columns: [{
          key: 'arch',
          type: 'arch',
          control: 'detail',
          items: ['currency', 'ledger', 'hash', 'signature'],
          title: '基础架构',
          icon: 'boxes',
          color: 'primary',
        },
        {
          key: 'comp',
          type: 'arch',
          control: 'detail',
          items: ['contracts', 'permission', 'api', 'consensus'],
          title: '基础组件',
          icon: 'cubes',
          color: 'success',
        },
        [{
          key: 'eco',
          type: 'eco',
          control: 'detail',
          items: ['incentive', 'governance', 'dapp'],
          title: '生态系统',
          icon: 'users',
          color: 'info',
        },
        {
          key: 'risk',
          type: 'risk',
          control: 'detail',
          title: '潜在风险',
          icon: 'exclamation-triangle',
          color: 'danger',
        },
        ],
        ],
      },
      simple: {
        name: '简化',
        id: 'simple',
        columns: [{
          key: 'comp',
          type: 'arch',
          control: 'compact',
          items: [
            'currency',
            'ledger',
            'hash',
            'signature',
            'contracts',
            'permission',
            'api',
            'consensus',
          ],
          title: '架构组件',
          icon: 'boxes',
          color: 'primary',
        },
        {
          key: 'eco',
          type: 'eco',
          control: 'detail',
          items: ['incentive', 'governance', 'dapp'],
          title: '生态系统',
          icon: 'users',
          color: 'info',
        },
        {
          key: 'risk',
          type: 'risk',
          control: 'detail',
          title: '潜在风险',
          icon: 'exclamation-triangle',
          color: 'danger',
        },
        ],
      },
      arch: {
        name: '仅架构',
        id: 'arch',
        columns: [{
          key: 'arch',
          type: 'arch',
          control: 'compact',
          items: ['currency', 'ledger', 'hash', 'signature'],
          title: '基础架构',
          icon: 'boxes',
          color: 'primary',
        },
        {
          key: 'comp',
          type: 'arch',
          control: 'compact',
          items: ['contracts', 'permission', 'api', 'consensus'],
          title: '基础组件',
          icon: 'cubes',
          color: 'success',
        },
        {
          key: 'risk',
          type: 'risk',
          control: 'detail',
          title: '潜在风险',
          icon: 'exclamation-triangle',
          color: 'danger',
        },
        ],
      },
    },
};

Object.entries(data.archData).map((kvp, idx) => {
  Object.entries(kvp[1]).map((nkvp, nidx) => {
    const obj: ArchItem = Object.assign({
      key: nkvp[0],
      categoryKey: kvp[0],
    }, nkvp[1]);
    data.archList.push(obj);
  });
});

Object.entries(data.ecoData).map((kvp, idx) => {
  Object.entries(kvp[1]).map((nkvp, nidx) => {
    const obj: EcoItem = Object.assign({
      key: nkvp[0],
      categoryKey: kvp[0],
    }, nkvp[1]);
    if (nkvp[1].id) { data.ecoList.push(obj); }
  });
});

// ========== for code generation
// let text = '';
// Object.entries(data.archData).map((kvp, idx) => {
//   text += `;\ntype ${kvp[0]}Options = `;
//   Object.entries(kvp[1]).map((nkvp, nidx) => {
//     text += ((nidx != 0 ? '|' : '') + `'${nkvp[0]}'`);
//   });
// });
// console.log(text);

// let text = '';
// Object.entries(data.archData).map((kvp, idx) => {
//   text += `${kvp[0]}: ${kvp[0]}Options;\n`;
// });
// console.log(text);

export default data;
